import { env } from '@/environment';
import { getStoredValue } from '@/helpers/util';
import { type TOptional } from '@/types/common';

export type TStorageAuth = {
  accessToken: string;
  email: string;
  expiresIn: number;
  isSocial: boolean;
  keepLoggedIn: boolean;
  refreshToken: string;
  socialProvider?: string;
  status: string;
  tokenType: string;
  userId: string;
  userType: string;
};

export const AUTH_STORAGE_KEY = 'Authorization';

export const getAuthFromStorage = () => getStoredValue(AUTH_STORAGE_KEY) as TOptional<TStorageAuth>;

export const getAccessTokenFromStorage = () => getAuthFromStorage()?.accessToken;

export const logout = async () => {
  const auth = getAuthFromStorage();
  if (!auth) return;
  try {
    await fetch(`${env.AUTH_BASE_URL}/logout`, {
      body: '{}',
      headers: {
        Authorization: `Bearer ${auth?.accessToken}`,
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
    localStorage.removeItem(AUTH_STORAGE_KEY);
  } catch (error) {
    console.error(error);
  }
};
